<template>
    <div class="navibar-wrap">
        <a-menu v-if="showCountrySwitch" mode="horizontal" class="user-menu country-menu-wrap" @click="onCountryMenuClick">
            <a-sub-menu key="country">
                <template #title>
                    <span class="country-trigger" :title="countryLabel">
                        <span class="country-flag">
                            {{ currentCountry === 'in' ? '🇮🇳' : currentCountry === 'br' ? '🇧🇷' : '🇵🇭' }}
                        </span>
                        <span class="country-label">{{ countryLabel }}</span>
                    </span>
                </template>
                <a-menu-item key="in" class="nav-user-dropdown">
                    <span class="country-menu-item">
                        <span class="country-flag">🇮🇳</span>
                        <span>印度</span>
                        <a-icon v-if="currentCountry === 'in'" type="check" class="country-check" />
                    </span>
                </a-menu-item>
                <a-menu-item key="br" class="nav-user-dropdown">
                    <span class="country-menu-item">
                        <span class="country-flag">🇧🇷</span>
                        <span>巴西</span>
                        <a-icon v-if="currentCountry === 'br'" type="check" class="country-check" />
                    </span>
                </a-menu-item>
                <a-menu-item key="ph" class="nav-user-dropdown">
                    <span class="country-menu-item">
                        <span class="country-flag">🇵🇭</span>
                        <span>菲律宾</span>
                        <a-icon v-if="currentCountry === 'ph'" type="check" class="country-check" />
                    </span>
                </a-menu-item>
            </a-sub-menu>
        </a-menu>
        <a-menu mode="horizontal" class="user-menu">
            <a-sub-menu key="user">
                <template #title>
                    <a-avatar shape="square" :size="40" :src="adminInfo.avatar">
                    </a-avatar>
                </template>
                <a-menu-item class="nav-user-dropdown">
                    <router-link :to="{name: 'AdminSettings'}">设置</router-link>
                </a-menu-item>
                <a-menu-item class="nav-user-dropdown">
                    <router-link :to="{name: 'Logout'}">退出</router-link>
                </a-menu-item>
            </a-sub-menu>
        </a-menu>
    </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import { GetLocalStorageT, GetSessionStorage, SetSessionStorage, STORE_KEY_ADMIN_INFO, STORE_KEY_CHANNEL_ID } from '@/utils/storage';
import { Admin } from '@/model/admin';
import {
    Config,
    getCountryLabel,
    getCurrentCountry as readCurrentCountry,
    setCurrentCountry as writeCurrentCountry,
} from '@/config';
import { NoneImage } from '@/utils/utils';

export default {
    setup() {
        let _info = GetSessionStorage(STORE_KEY_ADMIN_INFO);
        let adminInfo = _info ? _info : { username: "", avatar: NoneImage };
        if (!adminInfo) {
            new Admin().initByRequest().then((res) => {
                SetSessionStorage(STORE_KEY_ADMIN_INFO, {
                    username: res.username,
                    avatar: (Config.domainOss || "") + res.avatar,
                });
            }).then(() => {
                adminInfo = GetSessionStorage(STORE_KEY_ADMIN_INFO);
            });
        }

        const currentCountry = ref(readCurrentCountry());

        const showCountrySwitch = computed(() => String(GetLocalStorageT(STORE_KEY_CHANNEL_ID)) === "99");

        const countryLabel = computed(() => getCountryLabel(currentCountry.value));

        function onCountryMenuClick({ key }) {
            if (key !== 'in' && key !== 'br' && key !== 'ph') return;
            if (key === currentCountry.value) return;
            writeCurrentCountry(key);
            currentCountry.value = key;
            if (typeof window !== "undefined" && window.location) {
                window.location.reload();
            }
        }

        onMounted(() => {
            currentCountry.value = readCurrentCountry();
        });

        return {
            adminInfo,
            showCountrySwitch,
            currentCountry,
            countryLabel,
            onCountryMenuClick,
        };
    }
};
</script>

<style>
.navibar-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 16px;
    min-height: 64px;
}
.navibar-wrap > :not(:last-child) {
    margin-right: 8px;
}
.country-menu-wrap {
    margin-right: 0;
}
.user-menu {
    line-height: 64px;
    border-bottom: none !important;
}
.country-trigger {
    display: inline-flex;
    align-items: center;
    height: 64px;
    padding: 0 12px;
    cursor: pointer;
    user-select: none;
    transition: color .3s;
}
.country-trigger:hover {
    color: #1890ff;
}
.country-flag {
    font-size: 18px;
    margin-right: 6px;
    line-height: 1;
}
.country-label {
    font-size: 14px;
    color: rgba(0, 0, 0, .85);
}
.country-caret {
    margin-left: 4px;
    font-size: 12px;
    color: rgba(0, 0, 0, .45);
}
.country-menu-item {
    display: inline-flex;
    align-items: center;
    width: 100%;
}
.country-menu-item .country-flag {
    margin-right: 8px;
}
.country-check {
    margin-left: auto;
    color: #1890ff;
}

.anticon-menu-fold.trigger,
.anticon-menu-unfold.trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
}

.anticon-menu-fold.trigger:hover,
.anticon-menu-unfold.trigger:hover {
    color: #1890ff;
}

.nav-user-dropdown {
    background-color: #fff !important;
}
.nav-user-dropdown .ant-btn-link,
.nav-user-dropdown .ant-btn-link:hover,
.nav-user-dropdown .ant-btn-link:focus {
    color: black;
}
</style>
